import globalShim from "/home/user/src/Krunker_v7.1.4/src/shim/global.js";
const global = globalShim;
export { global };
